import {useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {IconHeader, JobDetailsIcon} from '../IconHeader/IconHeader';

import {BenefitsSection} from './BenefitsSection';
import {Column} from '../../../../../components/Column/Column';
import {orangeColors} from '../../../../../layouts/theme/designSystem';
import {Benefit} from '../../../../company/profile/types';

interface Props {
  benefits: Benefit[];
}

export const CompanyBenefits = ({benefits}: Props) => {
  const textColor = orangeColors[100];
  const {t} = useTranslation('translation', {
    keyPrefix: 'applicantDashboard.matchDetailsView.companyDetails.benefits',
  });

  const {happinessBenefits, officeBenefits, healthBenefits, financialBenefits} = useMemo(() => {
    const officeBenefits = benefits.filter((entry) => entry.category.categoryKey === 'office' && !!entry.selectedAt);
    const healthBenefits = benefits.filter((entry) => entry.category.categoryKey === 'health' && !!entry.selectedAt);
    const financialBenefits = benefits.filter(
      (entry) => entry.category.categoryKey === 'financial' && !!entry.selectedAt
    );
    const happinessBenefits = benefits.filter(
      (entry) => entry.category.categoryKey === 'happiness' && !!entry.selectedAt
    );

    return {officeBenefits, healthBenefits, financialBenefits, happinessBenefits};
  }, [benefits]);

  return (
    <Grid item md={12}>
      <Typography variant='h3' paddingBottom='16px'>
        {t('title')}
      </Typography>
      <Grid
        container
        display='flex'
        justifyContent='space-between'
        sx={{
          flexDirection: {xs: 'column', sm: 'row', md: 'row'},
        }}
      >
        <Column md={3} sm={4} sx={{paddingBottom: {xs: '32px'}}}>
          <BenefitsSection textColor={textColor} benefits={officeBenefits}>
            <IconHeader
              iconColor={textColor}
              icon={JobDetailsIcon.Building}
              text={t('office')}
              sx={{paddingBottom: '8px'}}
              minWidth='16px'
              variant='h4'
            />
          </BenefitsSection>
        </Column>
        <Column md={3} sm={4} sx={{paddingBottom: {xs: '32px'}}}>
          <BenefitsSection textColor={textColor} benefits={happinessBenefits}>
            <IconHeader
              iconColor={textColor}
              icon={JobDetailsIcon.Smiley}
              text={t('happiness')}
              minWidth='16px'
              sx={{paddingBottom: '8px'}}
              size='16px'
              variant='h4'
            />
          </BenefitsSection>
        </Column>
        <Column md={3} sm={4} sx={{paddingBottom: {xs: '32px'}}}>
          <BenefitsSection textColor={textColor} benefits={healthBenefits}>
            <IconHeader
              iconColor={textColor}
              icon={JobDetailsIcon.Spa}
              text={t('health')}
              minWidth='16px'
              sx={{paddingBottom: '8px'}}
              variant='h4'
            />
          </BenefitsSection>
        </Column>
        <Column md={3} sm={4} sx={{paddingBottom: {xs: '32px'}}}>
          <BenefitsSection textColor={textColor} benefits={financialBenefits}>
            <IconHeader
              iconColor={textColor}
              icon={JobDetailsIcon.Knowledge}
              text={t('financial')}
              minWidth='16px'
              sx={{paddingBottom: '8px'}}
              size='16px'
              variant='h4'
            />
          </BenefitsSection>
        </Column>
      </Grid>
    </Grid>
  );
};
